<template>
	<div v-if="error.msg !== ''">
		<a href="" @click.stop.prevent="close">X</a>

    <p >An error occured: </p>
		<p>{{ error.msg }}</p>
		<p>{{ error.reason }}</p>
		<p>{{ error.action }}</p>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ErrorInfo } from '../network';

@Options({
  props: {
    error: ErrorInfo
  },
  methods: {
    close() {
      this.error.msg = '';
    }
  }
})
export default class ErrorDisplay extends Vue {
  // props : [ 'error' ]
}
</script>

<style scoped>
div {
	position: absolute;
	border: 1px solid gold;
	background-color: rgb(77, 77, 77);
	width: 50vw;
	padding: 0px 15px 10px 15px;
}

div a {
	position: absolute;
	top: 7px;
	right: 7px;
}
</style>
